import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import "./PaymentSuccess.css";

const PaymentSuccess = () => {
  const navigate = useNavigate();

  return (
    <div className="payment-success-container">
      <div className="glass-background"></div>

      <div className="payment-content fade-in">
        <Card className="payment-card glass-panel glow-effect">

          <div className="payment-status success-box">
            <div className="success-icon bounce">✓</div>

            <h2 className="success-title">Payment Successful!</h2>
            <p className="success-subtext">Welcome to GrammAA Premium</p>

            <p className="success-message">
              You now have <strong>unlimited grammar checks</strong> and full access to every premium feature.
            </p>

            <div className="button-group">
              <Button 
                onClick={() => navigate("/checker")}
                className="glass-btn primary-btn"
              >
                Start Checking
              </Button>

              <Button
                variant="outline"
                onClick={() => navigate("/dashboard")}
                className="secondary-btn"
              >
                Go to Dashboard
              </Button>
            </div>
          </div>

        </Card>
      </div>
    </div>
  );
};

export default PaymentSuccess;
